import {
  CLEAR_REDUX,
  FULL_LICENCE_META_DATA,
} from "../actionTypes";

const initialState = {
  fullLicenceMetaData: {
    life_point: 0,
    experience_point: 0,
    licenseName: "You need a FrodoBots Driving Full Driving Pass",
    licenseImage: "",
    statusOfPass: '',
    nft_ids: []
  },
};

export const mintingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FULL_LICENCE_META_DATA:
      return {
        ...state,
        fullLicenceMetaData: action.payload.fullLicenceMetaData,
      };
    case CLEAR_REDUX:
      return initialState;
    default:
      return state;
  }
};
